import { mapValues } from 'lodash';
import activeFilterButton from './activeFilterButton';
import activeFilterClearAll from './activeFilterClearAll';
/**
 * Version 14 migrating new settings for the Session Filters.
 */
export default function v14(website) {
  return {
    ...website,
    eventVersion: 14,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'Agenda' && !layoutItem.config.style.sessionFilter.activeFilterButton) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            style: {
              ...layoutItem.config.style,
              sessionFilter: {
                ...layoutItem.config.style.sessionFilter,
                activeFilterButton: { ...activeFilterButton },
                activeFilterClearAll: { ...activeFilterClearAll }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}

